import useSWR from 'swr';

import {
  getLetterTemplateTypes,
  listLetterTemplates,
} from '@api/letter-templates';

export const LETTER_TEMPLATE_TYPES_KEY = 'letter-templates/types';
export const LETTER_TEMPLATES_KEY = 'letter-templates/list';

const OPTIONS = { revalidateOnFocus: false, shouldRetryOnError: false };

/**
 * The letter types and whether the caller may manage templates, or
 * `{ off: true }` while the server's feature switch is off. Shared by the
 * Settings tab list (to show the Templates tab) and the page, so it is one
 * request.
 */
export const useLetterTemplateTypes = () =>
  useSWR(LETTER_TEMPLATE_TYPES_KEY, getLetterTemplateTypes, OPTIONS);

/** The firm's live templates; not asked for until `enabled`. */
export const useLetterTemplates = (enabled: boolean) =>
  useSWR(enabled ? LETTER_TEMPLATES_KEY : null, listLetterTemplates, OPTIONS);
